import {make} from "vuex-pathify";
import jwtDecode from "jwt-decode";

const state = {
    profile: localStorage.getItem('token') ? jwtDecode(localStorage.getItem('token')) : {}
}
const mutations = make.mutations(state)

const actions = {}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
